"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RevisionType;
(function (RevisionType) {
    RevisionType[RevisionType["WITHOUT_REVIEW"] = 0] = "WITHOUT_REVIEW";
    RevisionType[RevisionType["MANUAL_REVIEW"] = 1] = "MANUAL_REVIEW";
    RevisionType[RevisionType["MANUAL_REVIEWED"] = 2] = "MANUAL_REVIEWED";
    RevisionType[RevisionType["MANUAL_REVIEWING_WITH_ERROR"] = 3] = "MANUAL_REVIEWING_WITH_ERROR";
    RevisionType[RevisionType["AUTOMATIC_RELEASE"] = 4] = "AUTOMATIC_RELEASE";
    RevisionType[RevisionType["MANUAL_EDITION_WITH_ERROR"] = 5] = "MANUAL_EDITION_WITH_ERROR";
})(RevisionType || (RevisionType = {}));
exports.default = RevisionType;
